import consumer from "./consumer"

document.addEventListener('turbolinks:load', () => {
  const map = document.getElementById('contactor-location-map')
  if (!map) {
    return
  }

  const roomId = map.getAttribute('data-inspection-id')

  consumer.subscriptions.create({ channel: "InspectionChatChannel", room: `inspection_location_${roomId}` }, {
    async received(data) {
      console.log('Received location data:', data);
      const mapElement = document.getElementById('contactor-location-map');
      mapElement.dataset.latitude = data.latitude;
      mapElement.dataset.longitude = data.longitude;
    },
  })
});
